import styled from "styled-components";

export const Container = styled.div`
  border-radius: 180px 120px 20px 20px;
  background-color: #f8f8f8;
  position: relative;
  cursor: default;

  @media (min-width: 1000px) {
    border-radius: 226px 180px 180px 0;
    min-height: 280px;
  }

  @media (min-width: 1188px) {
    border-radius: 0 216px;
  }
`;

export const Photo = styled.img`
  position: absolute;
  top: -6.75em;
  right: auto;
  user-select: none;
  transform: scaleX(-1);

  @media (min-width: 1000px) {
    left: 2em;
    top: -4.5em;
  }

  @media (min-width: 1188px) {
    transform: scaleX(1);
    left: 3em;
    top: -4em;
    right: auto;
  }
`;

export const Title = styled.h3`
  order: 0;
  font-weight: normal;
  margin: 0;

  @media (min-width: 1000px) {
    font-size: 1.5rem;
  }
`;

export const Message = styled.p`
  order: 2;
  margin: 0;
  color: #888;
  line-height: 150%;

  @media (min-width: 1000px) {
    margin: 1em 0 0.5em;
  }
`;

export const Position = styled.p`
  order: 4;
  align-self: flex-end;
  color: #bbb;
  margin: 0;
  user-select: none;
`;

export const RatingContainer = styled.div`
  order: 1;
  margin: 0.5em 0;

  @media (min-width: 1000px) {
    order: 3;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 2em;
  padding-top: 13em;

  @media (min-width: 1000px) {
    margin: 0 100px 0 300px;
    padding: 0;
    position: absolute;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 0 0 2.5em;
  }
`;

export const NextButton = styled.button`
  background: #e8f4fc;
  color: #1894e1;
  border: none;
  border-radius: 50%;
  font-size: 1.3em;
  line-height: 1;
  cursor: pointer;
  position: absolute;
  top: 1rem;
  right: 1rem;
  box-shadow: 0 0 0 4px white;
  height: 3.7rem;
  width: 3.7rem;

  @media (min-width: 1188px) {
    box-shadow: 0 0 0 8px white;
    top: 1.5rem;
    right: 1.8rem;
  }
`;
